﻿package com.ijoin.i18n

data class AppLanguage(
    val code: String,
    val nativeName: String,
    val englishName: String,
    val strings: Strings
)

object SupportedLanguages {
    val all: List<AppLanguage> = listOf(
        AppLanguage(code = "en", nativeName = "English", englishName = "English", strings = EnglishStrings),
        AppLanguage(code = "zh", nativeName = "中文", englishName = "Chinese", strings = ChineseStrings),
        AppLanguage(code = "hi", nativeName = "हिन्दी", englishName = "Hindi", strings = HindiStrings),
        AppLanguage(code = "es", nativeName = "Español", englishName = "Spanish", strings = SpanishStrings),
        AppLanguage(code = "ru", nativeName = "Русский", englishName = "Russian", strings = RussianStrings),
        AppLanguage(code = "fr", nativeName = "Français", englishName = "French", strings = FrenchStrings),
        AppLanguage(code = "ar", nativeName = "العربية", englishName = "Arabic", strings = ArabicStrings)
    )

    val default: AppLanguage = all.first()

    fun fromCode(code: String?): AppLanguage {
        if (code.isNullOrBlank()) return default
        val normalized = code.lowercase()
        val base = normalized.substringBefore("-")
        return all.firstOrNull { it.code.equals(base, ignoreCase = true) } ?: default
    }
}
